import { SokobanLevelDef } from "./levels";

export const LevelButton = ({
  level,
  isFocused,
  onPress,
}: {
  level: SokobanLevelDef;
  isFocused: boolean;
  onPress: () => void;
}) => (
  <button
    onClick={onPress}
    className="flex-col-center !absolute border-none bg-transparent cursor-pointer p-0 m-0 type-inherit-font"
    style={{
      left: level.x,
      top: level.y,
      transform: "translate(-50%, -50%)",
    }}
  >
    <div
      className={`flex-col-center w-[96px] h-[96px] rounded-full bg-white border-solid border-[6px] shadow-md ${
        isFocused ? "border-orange-100 scale-110" : "border-blue-50"
      }`}
    >
      <p className="title-text text-textcolor-black type-title">{level.id}</p>
    </div>
  </button>
);
